module.exports = {
    
    apiBase: "https://api.stage.banquet.ninja/api/v1"
};


// WEBPACK FOOTER //
// ./app/config/stage.js